/**
 * Valores iniciais do formulário de Level.
 */
export const levelDefaults = {
    name: "",
    value: 0,
    order: 0,
    status: "active"
};
